var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[(_vm.$store.state.corpInfo.footerInfo && _vm.$store.state.corpInfo.footerInfo.length > 0)?_c('DynamicFooter',{staticClass:"mx-auto"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }